export const brandColors = {
  primary: '#3fbb85',
  light: '#5cc596',
  dark: '#309865',
};